import Vue from 'vue/dist/vue.min.js';
import store from './store';

const ProductsAccessories = () => {
    const products = document.querySelectorAll('.products-acc__wrapper');

    let productsConstructor = (id) => {
        Vue.component('products-accessories-template', {
            data: function() {
                return {
                    paginated: null,
                    openText: '',
                    collapseText: '',
                    isExpanded: false,
                    totalItems: null,
                    initialItems: null,
                    buttonText: ''
                }
            },
            watch: {
                isExpanded: function() {
                    this.buttonText = this.isExpanded ? this.collapseText : this.openText;
                },
                paginated: function() {
                    if (this.paginated) {
                        this.$nextTick(() => {
                            this.openText = this.$refs.openButton.dataset.openText;
                            this.collapseText = this.$refs.openButton.dataset.collapseText;
                            this.buttonText = this.isExpanded ? this.collapseText : this.openText;
                        })
                    }
                }
            },
            methods: {
                handleClick() {
                    let contentArea = this.$refs.contentContainer;
                    let contentHeight = this.$refs.contentInner.getBoundingClientRect().height;

                    if (this.isExpanded == true) {
                        this.isExpanded = false;

                        requestAnimationFrame(function() {
                            //set content area height to content height to prevent transitioning from auto
                            contentArea.style.maxHeight = contentHeight + 'px';
                            // have the element transition to height: 0
                            requestAnimationFrame(function() {
                                contentArea.style.maxHeight = '0px';
                            });
                        });

                        contentArea.addEventListener('transitionend', () => {
                            contentArea.style.maxHeight = '0';
                        });

                    } else {
                        this.isExpanded = true;
                        contentArea.style.maxHeight = contentHeight + "px";
                        contentArea.addEventListener('transitionend', () => {
                            contentArea.style.maxHeight = 'none';
                        });
                    }
                },
                init() {
                    // init counts
                    this.initialItems = this.$refs.initialContent.querySelectorAll('.product-card').length;
                    this.moreItems = this.$refs.contentInner.querySelectorAll('.product-card').length;
                    this.totalItems = this.initialItems + this.moreItems;

                    this.paginated = this.moreItems > 0 ? true : false;

                    // init button only if paginated
                    if (this.paginated) {
                        this.$nextTick(() => {
                            this.openText = this.$refs.openButton.dataset.openText;
                            this.collapseText = this.$refs.openButton.dataset.collapseText;
                            this.buttonText = this.isExpanded ? this.collapseText : this.openText;
                        })
                    }
                }
            },
            mounted() {
                this.init();
            }
        });

        new Vue({
            el: `.products-accessories-${id}`,
            store: store,
        }).$mount(`.products-accessories-${id}`, true);

    }

    if (products.length > 0 ) {
        products.forEach((item, index) => {
            item.classList.add(`products-accessories-${index}`);
            productsConstructor(index);
        })
    }

}

export default ProductsAccessories;